import { render, staticRenderFns } from "./tambahluarprovinsi.vue?vue&type=template&id=563ecc1d&"
import script from "./tambahluarprovinsi.vue?vue&type=script&lang=js&"
export * from "./tambahluarprovinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports